/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TapeLibraryFsckEndpointRequest
 */
export interface TapeLibraryFsckEndpointRequest {
    /**
     * 
     * @type {string}
     * @memberof TapeLibraryFsckEndpointRequest
     */
    barcode: string;
}

export function TapeLibraryFsckEndpointRequestFromJSON(json: any): TapeLibraryFsckEndpointRequest {
    return TapeLibraryFsckEndpointRequestFromJSONTyped(json, false);
}

export function TapeLibraryFsckEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TapeLibraryFsckEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'barcode': json['barcode'],
    };
}

export function TapeLibraryFsckEndpointRequestToJSON(value?: TapeLibraryFsckEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'barcode': value.barcode,
    };
}


